import { render, staticRenderFns } from "./VppApplicationsList.vue?vue&type=template&id=45c81c1c"
import script from "./VppApplicationsList.vue?vue&type=script&lang=js"
export * from "./VppApplicationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports